import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAssesseeGuide } from "../../actions/guideActions";
import useDataSession from "../../customeHooks/useDataSession";

export default function GuideAssessee() {
  const [textData, setTextData] = useState("");
  const { dataSession } = useDataSession();
  const dispatch = useDispatch();
  const storeGet = useSelector((state) => state.smvm_get_assessee_guide);
  useEffect(() => {
    if (dataSession?.sessionInfo?.mehodId != undefined) {
      dispatch(GetAssesseeGuide(dataSession?.sessionInfo?.mehodId));
    }
  }, [dataSession?.sessionInfo?.mehodId]);
  useEffect(() => {
    if (storeGet.success) {
      setTextData(storeGet.data);
    }
  }, [storeGet]);
  const [showNum, setShowNum] = useState(1);
  const toggleShow = (n) => {
    setShowNum(n);
  };
  return (
    <div className="py-2 ">
      <section className="max-w-6xl mx-auto text-center ">
        <Accordion
          title="Guide"
          content={<Guide textD={textData} />}
          expanded={showNum == 1}
          toggleExpanded={() => toggleShow(1)}
        />
      </section>
    </div>
  );
}

const Guide = ({ textD }) => {
  return (
    <div className="ql-container ql-snow " style={{ border: "0px" }}>
      <div
        className="ql-editor "
        style={{
          minHeight: "initial",
          padding: "0px",
          maxHeight: "initial",
        }}
      >
        <div
          style={{ minHeight: "60px" }}
          dangerouslySetInnerHTML={{
            __html: textD,
          }}
        />
      </div>
    </div>
  );
};
// const lorem = `<h2>What is Lorem Ipsum?</h2><p class="ql-align-justify"><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p><h2>Why do we use it?</h2><p class="ql-align-justify">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p><p><br></p>`;

function Accordion({ title, content, toggleExpanded, expanded }) {
  // const [expanded, setExpanded] = useState(onShow);
  // const toggleExpanded = () => setExpanded((current) => !current);

  return (
    <div
      className="my-2 shadow-sm cursor-pointer bg-white pb-2"
      onClick={(e) => {
        e.preventDefault();
        toggleExpanded();
      }}
    >
      <div className="px-6 text-left items-center h-20 select-none flex justify-between flex-row ">
        <h5 className="flex-1 ">
          <label className="font-bold leading-tight text-secondary-500 text-lg ">
            {title}
          </label>
        </h5>
        {/* <div className="flex-none pl-2">
            {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </div> */}
      </div>
      <div
        className={`px-6 pt-0  transition-[max-height] duration-500 ease-in ${
          expanded ? "max-h-[80vh] overflow-auto " : "max-h-0 overflow-hidden "
        }`}
      >
        <div className="pb-4 text-left min-h-[60vh] ">{content}</div>
      </div>
    </div>
  );
}
